import React, { type JSX } from "react";

export type AdminAggregateSummaryItem = {
  id: string;
  label: string;
  value: string;
};

export type AdminAggregateSummaryStripProps = {
  title: string;
  items: AdminAggregateSummaryItem[];
  sourceGapLabel?: string;
  ariaLabel: string;
};

export function AdminAggregateSummaryStrip(
  props: AdminAggregateSummaryStripProps,
): JSX.Element {
  return (
    <section
      aria-label={props.ariaLabel}
      style={{
        display: "grid",
        gap: "12px",
        padding: "18px",
        borderRadius: "18px",
        background: "rgba(255, 255, 255, 0.82)",
        border: "1px solid rgba(24, 33, 43, 0.08)",
        boxShadow: "0 18px 36px rgba(15, 23, 42, 0.06)",
      }}
    >
      <div style={{ display: "grid", gap: "6px" }}>
        <p
          style={{
            margin: 0,
            color: "#64748b",
            fontSize: "0.78rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          {props.title}
        </p>
        {props.sourceGapLabel ? (
          <p style={{ margin: 0, color: "#475569", fontSize: "0.92rem", lineHeight: 1.6 }}>
            {props.sourceGapLabel}
          </p>
        ) : null}
      </div>

      {props.items.length > 0 ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "12px",
          }}
        >
          {props.items.map((item) => (
            <article
              key={item.id}
              style={{
                padding: "14px",
                borderRadius: "14px",
                background: "rgba(248, 250, 252, 0.92)",
                border: "1px solid rgba(148, 163, 184, 0.22)",
              }}
            >
              <p style={{ margin: 0, color: "#64748b", fontSize: "0.76rem", fontWeight: 700 }}>
                {item.label}
              </p>
              <p style={{ margin: "8px 0 0", color: "#18212b", fontSize: "1rem", fontWeight: 700 }}>
                {item.value}
              </p>
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
